var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelTrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u83DC\u5355icon/\u53D6\u6D88\u8BA2\u5355") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u83DC\\u5355icon/\\u53D6\\u6D88\\u8BA2\\u5355",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5B8C\\u6210\\u8BA2\\u5355"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.95,15.0125 L5.0578125,15.0125 C3.45,15.0125 2.1421875,13.7046875 2.1421875,12.096875 L2.1421875,5.221875 C2.1421875,3.6140625 3.45,2.30625 5.0578125,2.30625 L10.95,2.30625 C12.5578125,2.30625 13.865625,3.6140625 13.865625,5.221875 L13.865625,12.096875 C13.865625,13.7046875 12.5578125,15.0125 10.95,15.0125 Z M5.0578125,3.7078125 C4.2234375,3.7078125 3.54375,4.3875 3.54375,5.221875 L3.54375,12.096875 C3.54375,12.93125 4.2234375,13.6109375 5.0578125,13.6109375 L10.95,13.6109375 C11.784375,13.6109375 12.4640625,12.93125 12.4640625,12.096875 L12.4640625,5.221875 C12.4640625,4.3875 11.784375,3.7078125 10.95,3.7078125 L5.0578125,3.7078125 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0453125,4.3171875 L5.9640625,4.3171875 C5.946875,4.3171875 5.934375,4.303125 5.934375,4.2875 L5.934375,1.7296875 C5.934375,1.7125 5.9484375,1.6984375 5.965625,1.6984375 L10.0453125,1.6984375 C10.0625,1.6984375 10.0765625,1.7125 10.0765625,1.7296875 L10.0765625,4.2859375 C10.075,4.303125 10.0609375,4.3171875 10.0453125,4.3171875 L10.0453125,4.3171875 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.396875,5.0171875 L6.6125,5.0171875 C5.8515625,5.0171875 5.2328125,4.3984375 5.2328125,3.6375 L5.2328125,2.390625 C5.2328125,1.621875 5.8578125,0.9984375 6.625,0.9984375 L9.3828125,0.9984375 C10.1515625,0.9984375 10.7750029,1.6234375 10.7750029,2.390625 L10.7750029,3.6375 C10.7765625,4.3984375 10.15625,5.0171875 9.396875,5.0171875 Z M9.98105542,6.85488208 C10.2539544,7.12778111 10.2539544,7.56972284 9.98105542,7.84262187 L8.9058125,8.9184375 L9.98128424,9.99432571 C10.2541833,10.2672247 10.2541833,10.7091665 9.98128424,10.9820655 C9.70838522,11.2549645 9.26644348,11.2549645 8.99354446,10.9820655 L7.9178125,9.9064375 L6.84216422,10.9815131 C6.5692652,11.2544121 6.12621861,11.2555169 5.85331958,10.9826179 C5.58042056,10.7097189 5.58042056,10.2677772 5.85331958,9.99487813 L6.9298125,8.9184375 L5.85465326,7.84317429 C5.58175424,7.57027527 5.58175424,7.12833353 5.85465326,6.85543451 C6.12755228,6.58253549 6.56949402,6.58253549 6.84239304,6.85543451 L7.9178125,7.9304375 L8.99331563,6.85488208 C9.26621466,6.58198306 9.70815639,6.58198306 9.98105542,6.85488208 Z M9.3728125,2.3904375 L9.3734375,3.6171875 L6.6328125,3.6390625 L6.625,2.4 L9.3728125,2.3904375 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelTrade);
export default __webpack_public_path__ + "static/media/cancelTrade.85b018e0.svg";
export { ForwardRef as ReactComponent };